import React, { Component }     from 'react';

var checkbox = {
    position: 'relative',
    bottom: '1px',
    height: '16px',
    width: '16px',
    borderRadius: '3px',
    border: '1px solid #888'
}

var enabled =   {
    border: '10px solid #397',
    borderWidth: '0 0 4px 4px',
    transform: 'rotate(-50deg)',
    position: 'absolute',
    height: '4px',
    width: '10px',
    left: '1px',
    top: '3px'
}
var disabled =   {

}
export default class GroupBy extends Component {
    constructor(props) {
		super(props);
		this.state = {
            data: {
                ALL: false,
                Hour: false,
                "Day of Week": false,
                Month: false,
                Year: false,
                Holiday: false
            }
		}
	}

    toggle = (type) => (e) => {
        var newState = Object.assign({},this.state.data)

        if(type === 'ALL'){
            var newVal = newState[type] ? false : true
            for(var par in newState){
                newState[par] = newVal
            }
        }else {
            if(newState[type]){
                newState.ALL = false
            }
            newState[type] = newState[type] ? false : true
        }
        this.setState({data:newState})
    }

    confirm = () => {
        var send = {}
        for(var type in this.state.data){
            if(this.state.data[type] && type != 'ALL'){
                send[type] = true
            }
        }
        this.props.confirmDateFilters(send)
    }

    componentDidMount = () => {
        var newData = Object.assign({}, this.state.data)
        for(var type in this.props.data){
            if(this.props.data[type]){
                newData[type] = true
            }
        }
        this.setState({data:newData})
    }

	render() {
        var box = []
        for(var type in this.state.data){
            box.push(
                <div key={type} style={{padding: '5px',display: 'flex', flexFlow: 'row nowrap'}} onClick={this.toggle(type)}>
                    <div style={checkbox}>
                        {this.state.data[type] ? <div style={enabled}> </div> : <div style={disabled}> </div>}
                    </div>
                    <div style={{paddingLeft: '5px'}}>{type}</div>
                </div>
            )
        }


		return (
            <div className="blackout">
                <div style={{zIndex: 500, backgroundColor: '#fff',height: '300px', width: '180px',position: 'fixed', top: '50%', left: '50%', transform:' translate(-50%, -50%)',borderRadius: '10px',boxShadow: '0px 0px 5px #888'}}>
        			<div style={{padding: '15px',height: '200px', width: '130px',position: 'relative', display: 'flex', flexFlow: 'column wrap', justifyContent: 'space-between'}}>
                        {box}
        			</div>
                    <div className="button" style={{maxWidth: '120px', padding: '10px 15px'}}  onClick={this.confirm}>Confirm</div>
                </div>
            </div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/GroupBy.js